import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Product } from '../../../dto';
import { getProductStockBadges, ProductStockBadge } from '../../../common/product-stock.util';

@Component({
  selector: 'app-product-stock-badges',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './product-stock-badges.component.html',
  styleUrls: ['./product-stock-badges.component.scss'],
})
export class ProductStockBadgesComponent {
  @Input({ required: true }) product: Product;

  get stockBadges(): ProductStockBadge[] {
    return getProductStockBadges(this.product);
  }

  get hasStock(): boolean {
    return this.stockBadges.length > 0;
  }
}
